import { useSelector } from 'react-redux';
import { useKeyCodes } from './use-key-codes.js';
import { useMemo } from 'react';

export function useCloseKeys(containerRef, requestClose) {
  const passedCloseKeys = useSelector((state) => {
    return state.device.key_codes;
  });

  const closeKeys = useMemo(() => {
    return {
      [passedCloseKeys.RETURN]: requestClose,
      [passedCloseKeys.RED]: requestClose,
      [passedCloseKeys.HID_BACK]: requestClose,
      [27]: requestClose,
    };
  }, [passedCloseKeys, requestClose]);
  
  useKeyCodes(containerRef, closeKeys);
}
